module.exports = __webpack_public_path__ + "static/media/c2.29c2bfcc.svg";